// extracted by mini-css-extract-plugin
module.exports = {"container":"_d7e504f","result":"_d8acd701"};